import axios from 'axios'
import { API_KEY, API_URL, CUSTOMERS_KEY } from '../keys'

export const fileUpdateById = async (token: string, id: string, file: File) => {
	const formData = new FormData()
	formData.append('files', file)

	const response = await axios.put(`${API_URL}/files/${id}`, formData, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-files-key-validation': API_KEY,
			'sce-api-key': CUSTOMERS_KEY,
			'Content-Type': 'multipart/form-data',
		},
		validateStatus: (status) => status < 500,
	})
	if (response) return response
}
